import { type Gateway as GraftGateway } from '@graft/nuget-gc.webportals.gateways'

import { Gateway } from '../types/gateway.type'

import { hostedModuleToObject } from './hosted-module.object'
import { hostedRuntimeToObject } from './hosted-runtime.object'

export async function gatewayToObject(entity: GraftGateway): Promise<Gateway> {
  const [id, gatewayKey, name, dateCreated, numberOfCalls, status, hostedModulesRaw, hostedRuntimesRaw] =
    await Promise.all([
      entity.get_gatewayId(),
      entity.get_gatewayKey(),
      entity.get_name(),
      entity.get_dateCreated(),
      entity.get_numberOfCalls(),
      entity.get_status(),
      entity.get_modules(),
      entity.get_hostedRuntimes(),
    ])

  const [hostedModules, hostedRuntimes] = await Promise.all([
    Promise.all((hostedModulesRaw ?? []).map(hostedModuleToObject)),
    Promise.all((hostedRuntimesRaw ?? []).map(hostedRuntimeToObject)),
  ])

  return {
    id,
    gatewayKey,
    name,
    hostedModules,
    hostedRuntimes,
    dateCreated,
    numberOfCalls,
    status,
  }
}
